import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import useListeners from '@/hooks/wizard/useListeners';
import useTracking from '@/hooks/wizard/useTracking';
import useWizard from '@/hooks/wizard/useWizard';
import ReduxContainer from '@/ReduxContainer';
import ErrorWrapper from '@/views/ChefsDashboard/Components/Utils/ErrorWrapper';
import RequestWizardModal from './Containers/RequestWizardModal';
import RequestWizardEmbed from './Wrappers/RequestWizardEmbed';
import RequestWizardLoading from './States/RequestWizardLoading';
import { toast } from '@/utils/Toast';

const RequestWizard = ({
    id = 'bespokeQuoteModal',
    autoShow = false,
    embed = false,
}) => {
    const listners = useListeners(); // Register event listeners
    const tracking = useTracking(); // Register tracking events
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const Wizard = useWizard();
    const { status } = useSelector((state) => state.requestWizard);

    // Initialize the wizard
    useEffect(() => {
        if (is_node) return;

        Wizard.init({
            modalId: embed ? false : id,
            embed,
            autoShow,
            isMobile,
        });
    }, []);

    if (!status.init) {
        return embed ? (
            <div className="request-wizard__step flex-col my-5">
                <RequestWizardLoading />
            </div>
        ) : (
            <></>
        );
    }

    return embed ? <RequestWizardEmbed /> : <RequestWizardModal />;
};

const ErrorBlock = () => {
    const [toastShown, setToastShown] = useState(false);

    useEffect(() => {
        if (toastShown) return;
        setToastShown(true);

        toast({
            title: 'Unexpected error',
            text: 'Please contact support for assistance.',
            type: 'error',
        });
    }, [toastShown]);

    return <></>;
};

export default function RequestWizardContainer(props) {
    return (
        <ErrorWrapper
            view={<ErrorBlock />}
            message="Request Wizard Wrapper Error">
            <ReduxContainer>
                <RequestWizard {...props} />
            </ReduxContainer>
        </ErrorWrapper>
    );
}
